import React, { useEffect, useState } from "react"
import Table from "../../components/Table"
import styles from "./whatsAppInstances.module.css"
import ModalWhatsAppInstance from "../../components/Modal/ModalWhatsAppInstance"
import api from "../../services/api"
import Button from "../../components/Form/Button"
import Input from "../../components/Form/Input"
import { toast } from "react-toastify"
import Loading from "../layouts/Loading"
import { getOptionByOptionList } from "../../utils/utils"
import { useAuth } from "../../contexts/authContext"

const headers = [
    "#",
    "Nome",
    "Modo",
    "Contas",
    "Carga",
    "Prioridade",
    "Versão",
    "Status",
    ""
]

const optionsMode = [
    { id: "shared", value: "Compartilhado" },
    { id: "exclusive", value: "Exclusivo" },
    { id: "restricted", value: "Restrito" }
]

const WhatsAppInstances = () => {
    const [instances, setInstances] = useState([])
    const [instance, setInstance] = useState({})
    const [modalInstance, setModalInstance] = useState(false)
    const [textSearch, setTextSearch] = useState("")
    const [loading, setLoading] = useState(false)
    const [isNew, setIsNew] = useState(false)
    const [edit, setEdit] = useState(false)
    const { permissions } = useAuth()
    const canEditInstances = permissions?.manage_whatsapp_instances >= 1

    let isLoading = false

    useEffect(() => {
        getAllInstances()
    }, [])

    const getAllInstances = async () => {
        try {
            if (!isLoading) {
                isLoading = true
                setLoading(true)

                const response = await api.get("/integrations/whatsapp/instances")
                setInstances(response.data?.data || [])
            }
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
            isLoading = false
        }
    }

    const getInstanceById = async (id) => {
        try {
            setLoading(true)
            const response = await api.get(`/integrations/whatsapp/instances/${id}`)
            setInstance(response.data?.data)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const openModalInstance = async (isNew = false, edit = false, id = undefined) => {
        setIsNew(isNew)
        setEdit(edit)
        setInstance({})

        if (!isNew && id) {
            await getInstanceById(id)
        }

        setModalInstance(true)
    }

    const closeModalInstance = () => {
        setModalInstance(false)
    }

    const handleSave = (e, isNew, instance) => {
        e.preventDefault()
        isNew ? createInstance(instance) : updateInstance(instance)
    }

    const createInstance = (instance) => {
        setLoading(true)
        api.post("/integrations/whatsapp/instances", instance)
            .then(res => {
                if (res?.data?.data) {
                    setInstances(prev => [...prev, res.data.data])
                }
                toast.success(res.data.message)
                closeModalInstance()
            })
            .catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setLoading(false))
    }

    const updateInstance = (instance) => {
        setLoading(true)
        api.patch(`/integrations/whatsapp/instances/${instance._id}`, instance)
            .then(res => {
                setInstances(prev =>
                    prev.map(i => i._id === instance._id ? { ...i, ...instance } : i)
                )
                toast.success(res.data.message)
                setEdit(false)
            })
            .catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setLoading(false))
    }

    const getData = (instance) => ({
        id: instance._id,
        name: instance.name,
        value: [
            instance.name || "-",
            getOptionByOptionList(instance.mode, optionsMode) || "-",
            instance.account_ids?.length || 0,
            `${instance.current_load || 0}/${instance.max_inboxes || 0}`,
            instance.priority || 0,
            instance.version || "-",
            instance.is_active ? "Ativo" : "Inativo",
        ],
        actions: canEditInstances ? [
            {
                label: "Editar",
                onClick: (id) => openModalInstance(false, true, id)
            }
        ] : []
    })

    const getFiltered = () => {
        const data = instances.map(getData)

        return textSearch
            ? data.filter(row =>
                row.value.some(v =>
                    v?.toString().toLowerCase().includes(textSearch.toLowerCase())
                )
            )
            : data
    }

    return (
        <div className={styles.container}>
            <div className={styles.actions}>
                {canEditInstances && <Button variant="primary" onClick={() => openModalInstance(true, true)}>
                    Nova Instância
                </Button>}

                <Input
                    type="search"
                    placeholder="Buscar..."
                    value={textSearch}
                    onChange={(e) => setTextSearch(e.target.value)}
                />
            </div>

            <Table
                headers={headers}
                values={getFiltered()}
                messageNotRegisters="Nenhuma instância encontrada"
                onClick={(id) => openModalInstance(false, false, id)}
                showIndex
                showCount
                count={getFiltered().length}
            />

            {modalInstance && (
                <ModalWhatsAppInstance
                    closeModal={closeModalInstance}
                    onSubmit={handleSave}
                    isNew={isNew}
                    editable={edit}
                    canEdit={canEditInstances}
                    setEdit={setEdit}
                    value={instance}
                />
            )}

            {loading && <Loading fullPage />}
        </div>
    )
}

export default WhatsAppInstances
